<template>
    <div>
        <div class="page">
            <MaintenanceBanner />
            <div class="top">
                <div class="top-wrapper">
                    <div class="top-content">
                        <slot name="top-header">
                            <!--top-header-->
                        </slot>
                    </div>

                </div>

                <div class="header">
                    <div class="header-wrapper">
                        <div class="header-content">
                            <slot name="menu">
                                <!--header-->
                            </slot>
                        </div>
                    </div>
                </div>
            </div>

            <div class="body">
                <div class="body-wrapper">
                    <slot name="page-body">

                        <!--<div v-for="n in 1" :key="n" class="content-block">
                             [ body {{ n }} ] 
                        </div>-->

                    </slot>
                </div>
            </div>

            <div class="page-footer">
                <PageFooter />
            </div>

        </div>

    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageFooter from '@/layout/PageFooter.vue'
import MaintenanceBanner from '@/layout/MaintenanceBanner.vue'

    export default defineComponent({
        components: {
            PageFooter,
            MaintenanceBanner
        },
    })
</script>

<style lang="scss" scoped>

    .page {
        background-color: #2B4162;
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .top {
        width: 100%;
        height: 122px;
        background-color: var(--light-grey);

        &-wrapper {
            margin: 0 auto;
            max-width: 140rem;
        }

        &-content {
            height: 24px;
            padding: 25px 0;
        }
    }

    .header {
        max-width: 140rem;
        margin: 0 auto;
        background-color: white;
        width: 100%;
        border-radius: 25px;

        &-wrapper {
            padding: 25px;
        }

        &-content {
            height: 46px;
            display: flex;
            align-items: center;
        }
    }

    .body {
        width: 100%;
        max-width: 140rem;
        margin: 20px auto;

        &-wrapper {
            width: 100%;
            margin-top: 125px;
        }
    }

    .content-block {
        background-color: white;
        border-radius: 25px;
        padding: 25px;
    }

    .page-footer {
        margin-top: auto;
    }
</style>